export default {
    "en": {
        "common": {
            "save": "Save",
            "attach": "Attach",
            "open": "Open",
            "information": "Information",
            "confirm_action": "Confirm action?",
            "confirm": "Confirm",
            "cancel": "Cancel",
            "free": "Free",
            "public": "Public",
            "module": "Module",
            "modules": "Modules",
            "lesson": "Lesson",
            "lessons": "Lessons",
            "exercises": "Exercises",
            "exercise": "Exercise",
            "topics": "Polls",
            "back": "Back",
            "details": "Details",
            "views": "Views",
            "courses": "Courses",
            "course": "Course",
            "continue": "Continue",
            "start": "Start",
            "remove": "Remove",
            "apply": "Apply",
            "value": "Value",
            "status": "Status",
            "payment_method": "Payment method",
            "payment_error": "Checkout failed! The transaction could not be processed, please review the data provided and try again.",
            "due": "Due date",
            "installments": "Installments",
            "invoices": "View invoices",
            "all_invoices": "All invoices",
            "recurrence": "Revenues",
            "active": "Active",
            "inactive": "Inactive",
            "paid_value": "Amount paid",
            "to_due": "To due",
            "paid": "Paid",
            "paid_invoices": "Invoices paid",
            "due_invoices": "Invoices due",
            "plans": "Plans",
            "plan": "Plan",
            "blog": "Blog",
            "contact": "Contact",
            "products": "Products",
            "tickets": "Tickets",
            "notifications": "Notifications",
            "name": "Name",
            "showing": "Showing",
            "to": "to",
            "of": "of",
            "results": "Result",
            "unique_invoice": "Single invoice",
            "paid_date": "Pay day",
            "issue_date": "Purchase date",
            "expired": "Expired",
            "canceled": "Canceled",
            "processing": "Processing",
            "analyze": "In Analysis",
            "search": "Search",
            "print_billet": "Print Bill",
            "send": "Send",
            "close": "Close",
            "attention": "Attention!",
            "empty_exercises": "You haven't answered all the questions, do you really want to continue?",
            "empty_alert": "There are unanswered questions",
            "final_grade": "Grades",
            "billet": "Billet",
            "credit_card": "Credit card",
            "debit_card": "Debit card",
            "edit": "Edit",
            "add": "Add",
            "geolocation_block": "Location not allowed",
            "required_field": "Required field",
            "invalid_format": "Invalid format",
            "geolocation_permission": "Enable browser geolocation to log in",
            "geolocation_unsupported": "This browser does not support geolocation",
            "browser_support_file": "The browser does not support this type of file",
            "download_file": "Download file",
            "upload_error": "Could not send file",
            "chat": "Chat",
            "description": "Description",
            "generate_invoice": "Generate Invoice",
            "location": {
                "addresses": "Addresses",
                "address": "Address",
                "city": "City",
                "number": "Number",
                "neighborhood": "Neighborhood",
                "state": "State",
                "zip_code": "Zip Code",
                "info": "Complement"
            },
            "support_material": "Support material",
            "overview": "Overview",
            "empty_survey": "There are no polls at the moment",
            "no_forum": "No forums found",
            "final_content": "Final content",
            "content": "Content",
            "buy": "Buy",
            "about_course": "About the course",
            "listing": "Listing",
            "dashboard": "Panel",
            "cart": "Cart",
            "forum": "Forum",
            "new": "New",
            "financial": "Financial",
            "config": "Settings",
            "profile": "Profile",
            "receipt": "Receipt",
            "justify_answer": "Justify your answer",
            "select_one": "Select at least one option",
            "load_more_content": "Load more content",
            "title": "Title",
            "response": {
                "success": "Sent with success",
                "error": "There was an error, please try again."
            },
            "expand": "Expand",
            "see_less": "View less",
            "anonymous": "Anônimo",
            "my_plans": "My plans",
            "unavailable": "Unavailable",
            "store": "Plans",
            "zip_not_found": "An address with this zip code was not found.",
            "zip_error": "Could not load zip code information.",
            "type_search": "Type to search the country",
            "register": "Register",
            "blocked": "Blocked",
            "duration": "Duration",
            "days": "Days",
            "loading": "Loading...",
            "error_accessing_content": "Error accessing content."
        },
        "order": {
            "order": "Payment",
            "thanks": "Thank you very much for purchasing our content!",
            "info": "Payment Information",
            "recurrence_question": "Do you want to link this recurrence to a payment method?",
            "value": "Total Payment Amount",
            "yes_link": "Yes, I want to link",
            "no_link": "No",
            "go_to_dashboard": "Go to dashboard",
            "link_recurrence": "Link recurring payment for content"
        },
        "notification": {
            "title": "Notifications",
            "all": "All Notifications"
        },
        "billing": {
            "billing": "Revenues",
            "invoice": {
                "hash": "Invoice number",
                "descrition": "Invoice Description",
                "invoice": "Invoice",
                "invoices": "Invoices",
                "show": "View invoice",
                "pay": "Pay invoice",
                "duplicate": {
                    "title": "Duplicate",
                    "generate": "Generate duplicate"
                },
                "total": "Final invoice amount",
                "fee": "Fine",
                "interest": "Interest",
                "payed": "This invoice has already been paid",
                "processing": "Processing payment",
                "expiry": "Invoice Due Date",
                "expiry_duplicate": "Second Copy Expiration Date",
                "goto_payment": "Go to payment",
                "canceled": "Invoice has been canceled",
                "interest_per_days": "The day after the first invoice is due",
                "billet": {
                    "show": "Show billet",
                    "expirated": "Expirated invoice"
                }
            },
            "recurrence": {
                "status": "Status",
                "recurrence": "Recurrence",
                "subscription": "Subscription",
                "invoices": "Recurrence Invoices",
                "hash": "Recurrence Number",
                "description": "Recurrence Description",
                "due": "Next Expiration",
                "view": "View Recurrence",
                "payment_type": "Linked Payment Method",
                "info": "Recurrence Information",
                "name": "Recurrence Name",
                "plan": "Recurrence Plan",
                "value": "Recurrence Value",
                "cicle": "Cycles",
                "linked_payment": "This recurrence is linked with payment method ",
                "no_linked_payment": "This recurrence is not linked to any payment method",
                "link_payment": "Link Payment Method",
                "unlink_payment": "Unlink Payment Method",
                "null_recurring_payment": "No linked payment methods",
                "no_payment_available": "There are no recurrence payment method avaliable.",
                "status_codes": [
                    "Deactivate",
                    "Activate",
                    "Canceled",
                    "Processing"
                ]
            }
        },
        "glossary": {
            "title": "Glossary",
            "subtitle": "Look up the terms and concepts of your courses.",
            "search": "Search term",
            "all": "All",
            "category": "Category",
            "all_categories": "All categories",
            "course": "Course",
            "general": "General glossary",
            "empty": "No terms found.",
            "examples": "Usage examples",
            "synonyms": "Synonyms",
            "related": "See also",
            "back": "Back to glossary",
            "disabled": "The glossary is not available on this platform.",
            "not_found": "Term not found.",
            "preview_notice": "Student view: this is how students see the glossary.",
            "menu": "Glossary"
        },
        "tags": {
            "id": "Code",
            "year": "Year",
            "month": "Month",
            "next": "Next",
            "previous": "Previous"
        },
        "certificate": {
            "title": "Certificate",
            "description": "Certificate of completion, click on the trophy to get the certificate",
            "print": "Print",
            "download": "Downloadr",
            "validate": "Link to validate the Certificate",
            "code": "Enter the certificate code to validate",
            "validate_button": "Validate",
            "success": "This certificate is valid, check below",
            "error": "Please enter a valid certificate code",
            "validate_description": "Validate Certificate",
            "state": {
                "valid": "Valid certificate",
                "expired": "Expired certificate",
                "not_found": "Certificate not found",
                "disabled": "Public validation is off for this certificate",
                "valid_text": "This certificate was issued by the platform and is authentic.",
                "expired_text": "This certificate exists, but its validity date has passed.",
                "not_found_text": "We did not find a certificate with this code. Check the code and try again.",
                "disabled_text": "The certificate owner has not enabled public validation."
            },
            "summary": {
                "student": "Student",
                "content": "Content",
                "emitted_at": "Issued on",
                "valid_until": "Valid until",
                "code": "Code"
            },
            "validate_at": "Validate at"
        },
        "captcha": {
            "title": "Captcha verification error!",
            "none": "Captcha not created yet.",
            "image": "The selected image is incorrect.",
            "audio": "The letter or number is incorrect.",
            "incomplete": "You must complete the captcha.",
            "wait": "Too many attempts, please wait ",
            "frontend": {
                "accessibilityAlt": "Sound Icon",
                "accessibilityTitle": "Accessibility Option: listen to a question and answer it!",
                "accessibilityDescription": "Write down the <strong> answer </strong> to what you hear. Numbers or words:",
                "explanation": "Click or tap<strong>ANSWER</strong>",
                "refreshAlt": "Reload icon",
                "refreshTitle": "Reload: get new images and accessibility option!"
            },
            "images": {
                "Airplane": "Airplane",
                "Balloons": "Balloons",
                "Camera": "Camera",
                "Car": "Car",
                "Cat": "Cat",
                "Chair": "Chair",
                "Clip": "Clip",
                "Clock": "Clock",
                "Cloud": "Cloud",
                "Computer": "Computer",
                "Envelope": "Envelope",
                "Eye": "eye",
                "Flag": "Flag",
                "Folder": "Folder",
                "Foot": "Foot",
                "Graph": "Graph",
                "House": "House",
                "Key": "Key",
                "Leaf": "Leaf",
                "Light Bulb": "Lamp",
                "Lock": "Lock",
                "Magnifying Glass": "Magnifying Glass",
                "Man": "Man",
                "Music Note": "Musical note",
                "Pants": "Pants",
                "Pencil": "Pencil",
                "Printer": "Printer",
                "Robot": "Robot",
                "Scissors": "Scissors",
                "Sunglasses": "Glasses",
                "Tag": "Tag",
                "Tree": "Tree",
                "Truck": "Truck",
                "T-Shirt": "Shirt",
                "Umbrella": "Umbrella",
                "Woman": "Woman",
                "World": "Planet"
            }
        },
        "lesson": {
            "tabs": {
                "overview": "Overview",
                "polls": "Survey",
                "forum": "Forum"
            },
            "live": {
                "unavailable": "Live lesson not available",
                "start_at": "Start"
            },
            "conference": {
                "unavailable": "Videoconference not available",
                "start_at": "Start"
            },
            "answer_placeholder": "Write your answer",
            "finish_exercise": "End exercise",
            "redo": "Redo",
            "upload_empty": "The upload field cannot be empty",
            "answer_download": "Download answer",
            "exercise_waiting": "Exercise awaiting correction.",
            "exercise_revised": "Corrected exercise.",
            "obs": "Brokers note:",
            "revised_by": "Revised by:",
            "approved": "Approved exercise",
            "reproved": "Failed exercise",
            "conference_lesson": "Lesson: You can participate only as a listener",
            "conference_discussion": "Debate: you can interact, select the camera and microphone",
            "corrected_on": "Corrected in",
            "scorm": {
                "no_entry_sco": "SCORM package has no entry SCO.",
                "init_error": "Error starting SCORM session."
            }
        },
        "profile": {
            "secondary": {
                "title": "Secondary Login",
                "created": "Secondary Login Created",
                "deleted": "Secondary Login Deleted",
                "create": "Create Secondary Login",
                "delete": "Delete Secondary Login",
                "warning": "After deletion the email will completely lose its association with your account!",
                "new_secondary": "Create new user",
                "new_secondary_over_limit": "Secondary user limit reached"
            },
            "info": "Profile Information",
            "owner": "Main Login",
            "photo": "Profile picture",
            "additional_info": "Additional Information",
            "category": "Category",
            "document_not_unique": "There is already a student with the document registered"
        },
        "financial": {
            "sales_limit_exceeded": "Sales limit exceeded.",
            "invoices": {
                "attachment_success": "Voucher saved successfully",
                "attachment_failed": "Failed to save voucher"
            },
            "deposit": {
                "title": "Data for the deposit",
                "button": "Send receipt"
            }
        },
        "pdf": {
            "invoice_generated": "Generated Invoice",
            "invoice_number": "Invoice Number",
            "issue_date": "Emission",
            "due_date": "Due Date",
            "plan_name": "Plan",
            "items": "Items",
            "value": "Value",
            "total": "Total"
        },
        "topic": {
            "topic_title": "Topic title",
            "post": "Post",
            "title": "title",
            "await": "Waiting for approval",
            "question": "topical content",
            "new_moderated": "This forum is moderated by the administrator, your topic will appear in the listing when it is approved.",
            "needs_login": "Log in or create an account to interact on the topic"
        },
        "students": {
            "field_exits": "There is already a student with the value \"{value}\" in the {name} field.",
            "plan": {
                "remove": "Attention! When removing a plan associated with a student's account, it will lead to the loss of progress reports. If this plan has an associated recurrence, it will need to be removed manually. Do you want to proceed with the deletion of this student's plan?",
                "change_status": "Attention! When performing this action, the status of the plan for the student will be updated. If the \"Situation\" of the plan is updated to \"Activated\" it will unlock access for the student and if it is updated to \"Deactivated\" it will block access for the student. If this plan has an associated recurrence, it should be changed manually. Do you want to proceed with the change of this student's plan status?"
            }
        },
        "notification_templates": {
            "APP_TICKET_CREATED": {
                "name": "New Ticket Created",
                "body": "The administrator [[$user_name]] created ticket #[[$ticket_id]]."
            },
            "APP_TICKET_REPLY": {
                "name": "Ticket Answered",
                "body": "New administrator response [[$user_name]] on the ticket #[[$ticket_id]]."
            },
            "APP_TOPIC_REPLY": {
                "name": "New Forum Topic Reply",
                "body": "New topic reply [[$topic_name]] in the content forum [[$content_name]]."
            },
            "APP_TOPIC_REPLY_APPROVED": {
                "name": "Reply Approved on Forum Topic",
                "body": "Your answer in the topic [[$topic_name]] of the content [[$content_name]] was approved."
            },
            "APP_INVOICE_PAID": {
                "name": "Invoice Paid",
                "body": "Invoice payment #[[$invoice_id]] in the amount of [[$invoice_value]] referring to the plan [[$plan_name]] successfully approved."
            },
            "APP_INVOICE_DUE_DATE": {
                "name": "Overdue Invoice",
                "body": "We detected that the invoice #[[$invoice_id]] in the amount of [[$invoice_value]], due on date [[$invoice_due_date]] click for more information."
            },
            "APP_CORRECTED_EXERCISE": {
                "name": "Corrected Exercise",
                "body": "The exercise [[$exercise_name]] has been corrected check your note."
            },
            "APP_NEW_EXERCISE": {
                "name": "New Exercise",
                "body": "The exercise [[$exercise_name]] has been added to plan content [[$plan_name]]."
            },
            "APP_SUSPENDED_PLAN": {
                "name": "Suspended Plan",
                "body": "The plan [[$plan_name]] has been suspended due to pending payments. Click for more information."
            },
            "APP_NEW_MODULE": {
                "name": "New Module",
                "body": "The module [[$module_name]] has been added to the [[$course_name]] of the[[$plan_name]] plan."
            },
            "APP_NEW_LESSON": {
                "name": "New Class",
                "body": "The class [[$lesson_name]] \nhas been added to plan [[$plan_name]] content."
            }
        },
        "exercise": {
            "time": {
                "title": "Response timeout exercise",
                "description": "After starting the exercise, the sending must happen until the time limit expires, otherwise the sending will be automatic",
                "rules": "Once started, the timer will not stop even if the page is reloaded or a content change occurs",
                "remaining": "Time left",
                "limit": "Timeout exercise"
            },
            "validate": {
                "check_error": "Check some alternative",
                "some_question_no_anwser": "Answer all questions"
            }
        },
        "login": {
            "signin": "Log in",
            "signout": "Log out",
            "register": "Create an account",
            "new_account": "Create a new account",
            "continue": "Continue",
            "continue_user": "Continue as",
            "name": "Name",
            "email": "Email",
            "email_confirmation": "Confirm Email",
            "email_reset": "Reset Email",
            "email_change": "Change Email",
            "domain_invalid": "Incompatible email domain for selected category",
            "document": "Document",
            "document_type": "Document Type",
            "login_type": "Login form",
            "remember": "Remember Login",
            "disconnect_users": "Disconnect devices",
            "device_limit_hint": "Connected device limit reached. You can disconnect the other devices and continue on this one.",
            "disconnect_and_signin": "Disconnect other devices and sign in",
            "validation": {
                "email": "Email is required",
                "password": "Password is required"
            },
            "messages": {
                "update_password": "Update your password to continue",
                "success": "Update your password to continue",
                "error": "Invalid credentials"
            },
            "recovery": {
                "success": "You will receive an email with the link to reset your password",
                "error": "Email not found"
            },
            "password": {
                "title": "Password",
                "confirm": "Confirm the Password",
                "change": {
                    "title": "Change Password",
                    "success": "Password Changed!",
                    "error": "Error changing password"
                },
                "forgot": "Forgot password?",
                "reset": "Reset password"
            },
            "account_created": "Account created successfully! Redirecting...",
            "email_already_exists": "Email already has a registered account",
            "document_type_required": "Document is required",
            "subscribe_message": "Create your account to access",
            "has_account": "Already have an account?",
            "access_here": "Access here."
        },
        "chat": {
            "you_are_banned": "You have been banned from this chat, see your administrator for more information",
            "you_are_accept": "Your chat interaction has been granted",
            "cannot_approve": "You do not have permission to approve chat messages",
            "cannot_ban": "You do not have permission to ban a user",
            "send_placeholder": "Enter your message ...",
            "message_waiting": "Message sent. Wait for moderation.",
            "pending": "Awaiting approval",
            "message_sent_error": "Error sending message",
            "end": "Chat ended",
            "needs_login": "Log in or create an account to interact in chat"
        },
        "wiki": {
            "my_wikis": "My wikis",
            "title": "Wiki",
            "subtitle": "Build the content together with your class.",
            "empty": "You are not part of any wiki yet.",
            "course": "Course",
            "classroom": "Class",
            "relation": {
                "general": "General",
                "plan": "Plan: {name}",
                "course": "Course: {name}"
            },
            "open": "Open wiki",
            "status": {
                "not_started": "Opens on {date}",
                "editing": "Editing",
                "closed": "Closed"
            },
            "deadline": {
                "ends_in": "Due in {days} day|Due in {days} days",
                "ends_today": "Due today",
                "over": "Deadline over",
                "none": "No deadline",
                "not_started": "Opens on {date}"
            },
            "closed_notice": "Editing of this wiki has ended. You can still read it and browse the history.",
            "not_started_notice": "This wiki opens for editing on {date} at {time}. Until then, you can read the content.",
            "read_more": "Read full description",
            "read_less": "Collapse description",
            "participants": "participants",
            "contributions": "contributions",
            "last_update": "Last update",
            "today_at": "today at {time}",
            "yesterday": "yesterday",
            "pages": "Pages",
            "search_page": "Search page",
            "new_page": "New page",
            "new_page_title": "Page title",
            "parent_page": "Parent page (optional)",
            "no_parent": "No parent page",
            "create": "Create page",
            "cancel": "Cancel",
            "page_created": "Page created.",
            "page_locked": "Page locked by the teacher.",
            "locked_short": "Locked",
            "no_pages": "No pages yet.",
            "no_results": "No page found.",
            "select_page": "Pick a page to read.",
            "tabs": {
                "read": "Read",
                "edit": "Edit",
                "history": "History",
                "discussion": "Discussion"
            },
            "last_edit": "Last edit: {user}, {date}",
            "editor": {
                "bold": "Bold",
                "italic": "Italic",
                "heading": "Heading",
                "list": "List",
                "table": "Table",
                "link": "Link",
                "link_url": "Link address",
                "insert": "Insert",
                "summary": "Change summary (optional)",
                "summary_placeholder": "Describe what you changed.",
                "save": "Save change",
                "being_edited": "{user} is editing this page…",
                "cannot_edit": "You cannot edit this page.",
                "conflict_title": "The page was changed by someone else",
                "conflict_text": "Your text was kept below. Compare it with the current version and save again once adjusted.",
                "conflict_mine": "My draft",
                "conflict_theirs": "Current version",
                "use_current": "Discard my draft and load the current version",
                "keep_mine": "Keep my draft",
                "unsaved": "You have unsaved changes on this page. Leave without saving?"
            },
            "files": {
                "send": "Upload file",
                "hint": "Images show up in the text; PDF, PPTX, DOCX, XLSX show up as a downloadable file. Up to 25 MB.",
                "sent": "File uploaded.",
                "invalid": "File not allowed. Upload PNG, JPG, GIF, WEBP, PDF, PPTX, DOCX or XLSX up to 25 MB.",
                "uploading": "Uploading…",
                "remove": "Remove",
                "removed": "File removed."
            },
            "file_download": "Download",
            "history": {
                "version": "Version {number}",
                "by": "by {user}",
                "view": "View version",
                "back": "Back to history",
                "current": "Current",
                "empty": "No versions.",
                "teacher_only": "Restoring versions is up to the teacher."
            },
            "discussion": {
                "title": "Discussion",
                "type": "Type",
                "types": {
                    "question": "Question",
                    "suggestion": "Suggestion",
                    "justification": "Justification",
                    "debate": "Debate"
                },
                "write": "Write your comment",
                "publish": "Publish",
                "reply": "Reply",
                "replying_to": "Replying to {user}",
                "empty": "No comments yet. Start the discussion.",
                "teacher": "TEACHER",
                "closed": "The discussion of this wiki is closed. You can read the comments but not post."
            },
            "feed": {
                "title": "Latest changes",
                "created": "created the page {page}",
                "edited": "{summary} on {page}",
                "commented": "commented on {page}",
                "empty": "No changes yet."
            },
            "version_created": "Page created",
            "version_edited": "Change",
            "version_restored": "Version {number} restored",
            "version_teacher": "Teacher change",
            "cannot_create": "You cannot create pages in this wiki.",
            "cannot_edit": "You cannot edit this page.",
            "conflict": "The page was changed by someone else while you were editing.",
            "saved": "Change saved.",
            "comment_published": "Comment published.",
            "error": "Could not complete. Try again."
        },
        "empty": {
            "unique_invoice_title": "No invoices to show",
            "unique_invoice_subtitle": "Here all your unique invoices will appear.",
            "recurrence_title": "No recurrences to show.",
            "recurrence_subtitle": "Here all your recurrences will appear.",
            "filter_title": "Your search returned no results",
            "filter_subtitle": "Try again with new parameters",
            "topic_title": "No topics found"
        },
        "auth": {
            "failed": "Invalid credentials",
            "device": "Device limit connected with this account reached",
            "userselect": "Select your user to continue",
            "terms_accept": "You must accept the terms of use before continuing",
            "deactivated": "Student is suspended from the platform!"
        },
        "form": {
            "address": {
                "country": "Country",
                "state": "State",
                "city": "City",
                "address": "Address",
                "number": "Number",
                "neighborhood": "Neighborhood",
                "info": "Complement",
                "cep": "Zip code",
                "invalid_zip": "Invalid zip code",
                "fill_zip": "Fill in the zip code field"
            }
        },
        "content": {
            "course_content": "Course content",
            "lesson_content": "Lesson Content",
            "description": "Description",
            "download_content": "Downloadable content",
            "lock": {
                "PLAN_EXPIRED": "This plan has expired",
                "PLAN_UNAVAILABLE": "Plan unavailable",
                "SCHEDULE": "Scheduled content {details}",
                "SCHEDULE_SALE": "Released after {details}",
                "PROGRESS": "Minimum {details} progress not achieved",
                "GRADE": "Minimum grade {details} not reached",
                "AVAILABLE": "Available content",
                "UNAVAILABLE": "Unavailable content",
                "VIEWS_LIMIT": "View limit reached",
                "WAITING_AUTHORIZATION": "Awaiting authorization",
                "WAITING_EXTERNAL_STATUS": "Unconfirmed enrollment",
                "NOT_FREE_AFTER_CONTENT": "It is necessary to wait for {details} days until you release this class or unlock the previous content."
            },
            "uploads": {
                "url": "Url",
                "open_link": "Open file",
                "upload": "Upload",
                "title": "Uploads",
                "create": "Send Files",
                "edit": "Edit file",
                "files": "Files",
                "file": "File",
                "various_files": "Misc Files",
                "unsupported_preview": "No preview available",
                "name": "Name",
                "clear_list": "Clear queue",
                "description": "Description",
                "send_file": "Send file",
                "send_image": "Send image",
                "send_media": "Send files",
                "message": "Drag and drop your file here",
                "info": "Or",
                "remove": "Remove File",
                "cancel": "Cancel upload",
                "confirm": "Are you sure you want to cancel the submission?",
                "unsupported": "Your browser does not support sending by dragging the file",
                "fallback": "Please use the form to send the file",
                "type": "It is not possible to send files with this format",
                "exceeded": "Submit at most",
                "once": "once",
                "error": "Failed to upload file.",
                "canceled": "Sending canceled",
                "validate": "Select a file",
                "created_at": "Send date",
                "sent": "Sent",
                "size": "Size",
                "change": "Send file",
                "attachment": "Attachment",
                "docs": "Documents",
                "images": "Images",
                "videos": "Videos",
                "audios": "Audios",
                "all": "All files",
                "select": "Select",
                "use": "Select",
                "media_gallery": "Media Gallery",
                "rules_failed": "You have reached the maximum download limit"
            },
            "exercise": {
                "exercise": "Exercise",
                "questions": "Questions:",
                "utilization": "Utilization"
            },
            "lesson": {
                "video": "Video Content",
                "video_n": "Video",
                "upload": "Support file"
            },
            "type": {
                "live": "Live",
                "file": "File"
            },
            "open": {
                "new_tab": "New tab"
            }
        },
        "cart": {
            "recurrence": {
                "title": "Recurrences",
                "monthly": "Monthly",
                "bimonthly": "Bimonthly",
                "quarterly": "Quarterly",
                "semiannual": "semiannual",
                "yearly": "Yearly",
                "custom": "Charged every",
                "days": "Days",
                "change_payment": "Choose the recurrence payment method",
                "cpf": "CPF",
                "area_code": "Area code",
                "phone_number": "Telephone number",
                "name": "Name",
                "holder": "Holder",
                "gerencia_net": "Net Management",
                "birth": "Date of birth",
                "credit_card_brand": "Card banner",
                "credit_card_number": "Card Number",
                "credit_card_cvv": "CVV",
                "credit_card_expiration_month": "Card Expiration Month",
                "credit_card_expiration_year": "Card Expiration Year",
                "card_holder": "Card Holder Name (as written on the card)",
                "holder_cpf": "Holder CPF",
                "payment_alert": "Only 1 item of the recurring type in the cart is allowed if the payment method is GerenciaNet",
                "approve_text": "Approve Recurrence",
                "have_recurrence": "Attention, you already have an item in your cart, to add a recurring item you must complete the purchase or clean the cart"
            },
            "coupon": {
                "has_coupon": "Have a discount coupon?",
                "placeholder": "CODE",
                "apply": "To apply",
                "discount_coupon": "Discount coupon",
                "coupon": "Coupon",
                "add": "Apply a discount coupon"
            },
            "add_item": {
                "failed": "Failed to add item to cart",
                "recurrence_failed": "Recurring item already added to cart"
            },
            "pay": "Make Payment",
            "change_payment": "Fill in the payment details",
            "cart": "Shopping cart",
            "go_to_cart": "Go to Cart",
            "subscribe": "Sign up",
            "add_to_cart": "Add to cart",
            "access_plan": "Access Plan",
            "plan_info": "Plan information",
            "payment_type": "Form of payment",
            "product": "Product",
            "price": "Price",
            "checkout": "Payment",
            "type": "Plan Period",
            "type_recurrence": "Recurring Payment",
            "type_unique": "Single Payment",
            "discount": "Discount",
            "total": "Total",
            "finish": "Finish",
            "empty": "Your cart is empty",
            "empty_message": " Before going to checkout you must add some product to your cart.",
            "empty_button": "Keep buying",
            "currency": "Currency",
            "filter": "Filter",
            "filter_by": "Filter by",
            "remove_failed": "Trying to remove item from cart failed",
            "admin_message": "It was not possible to make the purchase, make sure you are logged in as a student",
            "plans": {
                "types": "Types of Plans",
                "public": "Public",
                "free": "Free",
                "single_purchase": "Single Payment",
                "recurrence": "Recurrent",
                "value": "Plan Amount"
            },
            "min_price": "Lowest price",
            "max_price": "Biggest price",
            "clean_filters": "Clear Filters",
            "clear": "Limpar o Carrinho",
            "item_added": "Item added to cart!",
            "code": "Code",
            "code_empty": "Mandatory code",
            "free_item_add": "Enrolled successfully!",
            "free_item_wait": "Plan added to your account, wait for authorization for your subscription",
            "deleted": "Cart item successfully removed!",
            "item": {
                "added": "Item added to cart!",
                "removed": "Item removed from cart",
                "exists": "Product already added to cart"
            },
            "checkout_errors": {
                "brand_not_identified": "We could not identify the card brand. Check the card number or select the brand manually.",
                "brand_not_accepted": "The {brand} brand is not accepted by this payment method.",
                "pending_invoice_multiple": "There is already an open invoice for one of the cart items. Pay the invoice under Financial or remove the item to continue.",
                "payment_reversed": "The card charge was automatically cancelled and no amount will be debited.",
                "payment_not_reversed": "The charge could not be cancelled automatically. Please contact support with the time of the purchase."
            }
        },
        "blog": {
            "share": "Share",
            "share_on": "Share on: social",
            "copy_url": "Copy url",
            "posts": {
                "by": "Published by",
                "views": "Views",
                "search": "Search publication",
                "latest": "Latest publications",
                "no_data": "No posts"
            },
            "comments": {
                "title": "Comments",
                "reply_to": "Answer to: author",
                "no_replies": "No answer",
                "show_replies": "Show replies",
                "login_comment": "Log in and leave your comment",
                "form_title": "leave a comment",
                "no_data": "No comments yet",
                "send": "Submit",
                "reply": "Reply",
                "replies": "Replies",
                "load_more": "View more comments"
            },
            "categories": {
                "title": "categories",
                "more": "Show more"
            },
            "tags": {
                "see_more": "See more about:"
            }
        },
        "header": {
            "cart": {
                "empty": "Your shopping cart is empty."
            },
            "profile": {
                "title": "Profile",
                "logout": "Log out",
                "welcome": "Welcome",
                "notifications": "Notifications",
                "cart": "Cart",
                "menus": "Menus"
            },
            "notifications": {
                "you_have": "You have",
                "notification": "notification.",
                "notifications": "notifications.",
                "all": "View All",
                "ago": "ago",
                "markerAllRead": "Mark all as read"
            }
        },
        "support": {
            "submit": "Contact Us",
            "support_form": "Contact Form",
            "label": "Subject matter",
            "invalid_email": "Invalid email",
            "sent_success": "Contact email sent successfully!",
            "chat": {
                "title": "Support Chat",
                "attendant": "Attendant",
                "send_placeholder": "Enter your message ...",
                "err_send_message": "Error sending message"
            },
            "departments": {
                "department": "Departament"
            },
            "tickets": {
                "ticket": "Ticket",
                "view": "View Ticket",
                "id": "ID",
                "all": "All tickets",
                "title": "subject matter",
                "search": "Search by title or ID",
                "reply": "Message",
                "reply_error": "Failed to send response",
                "created_at": "Created on",
                "status": "Situation",
                "close": "Close Ticket",
                "new": "New ticket",
                "send": "Message sent",
                "situation": {
                    "all": "All",
                    "OPEN": "Open",
                    "WAITING_STUDENT": "Waiting your answer",
                    "WAITING_OP": "Waiting for operator",
                    "CLOSED": "Closed",
                    "RESOLVED": "Resolved",
                    "IN_PROCESS": "in attendance"
                }
            },
            "map": {
                "contact_info": "Contact information",
                "telephone": "Telefone",
                "address": "Address"
            }
        },
        "course": {
            "tabs": {
                "wiki": "Class wiki",
                "glossary": "Glossary",
                "overview": "Overview",
                "content": "Content",
                "forum": "Forum"
            },
            "start": "Start",
            "continue": "Continue",
            "modules": "Modules",
            "lessons": "Lessons",
            "exercises": "Exercises",
            "topics": "Topics",
            "show_more": "Show more",
            "module_no_content": "This module has no content",
            "course_no_content": "There is no content available for viewing at the moment"
        },
        "tickets": {
            "empty": {
                "title": "Oops! You have no tickets",
                "subtitle": "You can create a new ticket by clicking below",
                "button": "New ticket"
            }
        },
        "validation": {
            "accepted": "The {attribute} field must be accepted.",
            "active_url": "The {attribute} field it is not a valid URL.",
            "after": "The {attribute} field must be a date after {date}.",
            "after_or_equal": "The {attribute} field must be a date later than or equal to {date}.",
            "alpha": "The {attribute} field can only contain letters.",
            "alpha_dash": "The {attribute} field it can only contain letters, numbers and dashes.",
            "alpha_num": "The {attribute} field it can only contain letters and numbers.",
            "array": "The {attribute} field it must be a matrix.",
            "before": "The {attribute} field must be an earlier date {date}.",
            "before_or_equal": "The {attribute} field must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} field must be between {min} and {max}.",
                "file": "The {attribute} field must be between {min} and {max} kilobytes.",
                "string": "The {attribute} field must be between {min} and {max} characters.",
                "array": "The {attribute} field must have between {min} and {max} items."
            },
            "err": "Validation error",
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} field does not match.",
            "date": "The {attribute} field is not a valid date.",
            "date_format": "The {attribute} field does not match the {format} format.",
            "different": "The {attribute} fields and {other} fields must be different.",
            "digits": "The {attribute} field must have {digits} digits.",
            "digits_between": "The {attribute} field must be between {min} and {max} digits.",
            "dimensions": "The {attribute} field has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} field must be a valid email address.",
            "exists": "The {attribute} field selected is invalid.",
            "file": "The {attribute} field must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} field must be an image.",
            "in": "The {attribute} field selected is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} field must be an integer.",
            "ip": "The {attribute} field must be a valid IP address.",
            "ipv4": "The {attribute} field must be must be a valid IPv4 address.",
            "ipv6": "The {attribute} field must be a valid IPv6 address.",
            "json": "The {attribute} field must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} field cannot be greater than {max}.",
                "file": "The {attribute} field cannot be greater than {max} kilobytes.",
                "string": "The {attribute} field cannot have more than {max} characters.",
                "array": "The {attribute} field cannot have more than {max} items."
            },
            "mimes": "The {attribute} field must be a file of type: {values}.",
            "mimetypes": "The {attribute} field must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} field must be at least {min}.",
                "file": "The {attribute} field must be at least {min} kilobytes.",
                "string": "The {attribute} field must be at least {min} characters.",
                "array": "The {attribute} field must have at least {min} items."
            },
            "not_in": "The {attribute} field selected is invalid.",
            "numeric": "The {attribute} field must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} field has an invalid format.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field  is mandatory except when {other} is {values}.",
            "required_with": "The {attribute} field  is required when {values} is present.",
            "required_with_all": "The {attribute} field  is required when {values} is present.",
            "required_without": "The {attribute} field is mandatory when {values} is not present.",
            "required_without_all": "The {attribute} field is mandatory when none of the {values} are present.",
            "same": "The {attribute} and {other} fields must match.",
            "size": {
                "numeric": "The {attribute} field must be {size}.",
                "file": "The {attribute} field must be {size} kilobytes.",
                "string": "The {attribute} field must be {size} characters.",
                "array": "The {attribute} field must contain {size} items."
            },
            "string": "The {attribute} field must be a string.",
            "timezone": "The {attribute} field must be a valid zone.",
            "unique": "The {attribute} field is already in use.",
            "uploaded": "Failed to upload the {attribute} field.",
            "url": "The {attribute} field has an invalid format.",
            "white_space": "The {attribute} field must not contain blanks.",
            "reserved_in_system": "Esse nome é reservado pelo sistema.",
            "custom": {
                "already_exists": "A record with this value already exists.",
                "fields": "Mandatory fields not filled in",
                "document": {
                    "unique": "There is already a student with the document registered."
                },
                "email": {
                    "unique": "There is already a student with the registered email"
                }
            },
            "attributes": {
                "document": "documento"
            }
        },
        "dashboard": {
            "courses": "Courses",
            "content": "Content",
            "lessons": "Lessons",
            "exercises": {
                "title": "Exercises",
                "answers": "Questions Answered"
            },
            "plan": {
                "change": "Change Plan",
                "external_status_title": "Confirmation of enrollment",
                "external_status_description": "Hello {name}, we are looking forward to starting activities. To confirm your registration, click the button below.",
                "external_status_ok": "Confirm registration",
                "unavailable_content": "Content not available yet",
                "release_date": "Release date: "
            },
            "plans": "Plans",
            "in_progress": "In Progress",
            "no_plans": "You have no plan",
            "empty_message": "Purchase at least one plan to access your content",
            "redirect_showcase": "Plans Showcase",
            "access": "Acess",
            "start": "Start",
            "continue": "Continue",
            "disabled": "Disabled",
            "progress": "Progress",
            "notifications": {
                "title": "Dashboard Notifications",
                "name": "Notifications"
            },
            "expiration_days": "Expiration days",
            "expiration_date": "Expiration date",
            "tomorrow": "Tomorrow",
            "today": "Today",
            "expired": "Expired"
        }
    },
    "es": {
        "glossary": {
            "title": "Glosario",
            "subtitle": "Consulte los términos y conceptos de sus cursos.",
            "search": "Buscar término",
            "all": "Todos",
            "category": "Categoría",
            "all_categories": "Todas las categorías",
            "course": "Curso",
            "general": "Glosario general",
            "empty": "No se encontraron términos.",
            "examples": "Ejemplos de uso",
            "synonyms": "Sinónimos",
            "related": "Ver también",
            "back": "Volver al glosario",
            "disabled": "El glosario no está disponible en esta plataforma.",
            "not_found": "Término no encontrado.",
            "preview_notice": "Vista del alumno: así ven los alumnos el glosario.",
            "menu": "Glosario"
        },
        "login": {
            "signin": "Entrar",
            "email": "Email",
            "password": "Senha",
            "remember": "Lembrar Login",
            "messages": "Mensages",
            "validation": {
                "email": "Email é obrigatório",
                "password": "Password é obrigatório"
            },
            "message": "Mensagem"
        },
        "wiki": {
            "my_wikis": "Mis wikis",
            "title": "Wiki",
            "subtitle": "Construye el contenido junto con tu clase.",
            "empty": "Todavía no participas en ninguna wiki.",
            "course": "Curso",
            "classroom": "Clase",
            "relation": {
                "general": "General",
                "plan": "Plan: {name}",
                "course": "Curso: {name}"
            },
            "open": "Abrir wiki",
            "status": {
                "not_started": "Abre el {date}",
                "editing": "En edición",
                "closed": "Cerrada"
            },
            "deadline": {
                "ends_in": "Vence en {days} día|Vence en {days} días",
                "ends_today": "Vence hoy",
                "over": "Plazo cerrado",
                "none": "Sin plazo",
                "not_started": "Abre el {date}"
            },
            "closed_notice": "La edición de esta wiki ha terminado. Aún puedes leerla y consultar el historial.",
            "not_started_notice": "Esta wiki abre para edición el {date} a las {time}. Hasta entonces, puedes leer el contenido.",
            "read_more": "Leer descripción completa",
            "read_less": "Ocultar descripción",
            "participants": "participantes",
            "contributions": "contribuciones",
            "last_update": "Última actualización",
            "today_at": "hoy a las {time}",
            "yesterday": "ayer",
            "pages": "Páginas",
            "search_page": "Buscar página",
            "new_page": "Nueva página",
            "new_page_title": "Título de la página",
            "parent_page": "Página madre (opcional)",
            "no_parent": "Sin página madre",
            "create": "Crear página",
            "cancel": "Cancelar",
            "page_created": "Página creada.",
            "page_locked": "Página bloqueada por el profesor.",
            "locked_short": "Bloqueada",
            "no_pages": "Ninguna página todavía.",
            "no_results": "Ninguna página encontrada.",
            "select_page": "Elige una página para leer.",
            "tabs": {
                "read": "Leer",
                "edit": "Editar",
                "history": "Historial",
                "discussion": "Discusión"
            },
            "last_edit": "Última edición: {user}, {date}",
            "editor": {
                "bold": "Negrita",
                "italic": "Cursiva",
                "heading": "Título",
                "list": "Lista",
                "table": "Tabla",
                "link": "Enlace",
                "link_url": "Dirección del enlace",
                "insert": "Insertar",
                "summary": "Resumen del cambio (opcional)",
                "summary_placeholder": "Describe lo que cambiaste.",
                "save": "Guardar cambio",
                "being_edited": "{user} está editando esta página…",
                "cannot_edit": "No puedes editar esta página.",
                "conflict_title": "Otra persona modificó la página",
                "conflict_text": "Tu texto se mantuvo abajo. Compáralo con la versión actual y guarda de nuevo cuando lo ajustes.",
                "conflict_mine": "Mi borrador",
                "conflict_theirs": "Versión actual",
                "use_current": "Descartar mi borrador y cargar la versión actual",
                "keep_mine": "Seguir con mi borrador",
                "unsaved": "Tienes cambios sin guardar en esta página. ¿Salir sin guardar?"
            },
            "files": {
                "send": "Enviar archivo",
                "hint": "Las imágenes aparecen en el texto; PDF, PPTX, DOCX, XLSX aparecen como archivo para descargar. Hasta 25 MB.",
                "sent": "Archivo enviado.",
                "invalid": "Archivo no permitido. Envía PNG, JPG, GIF, WEBP, PDF, PPTX, DOCX o XLSX de hasta 25 MB.",
                "uploading": "Enviando…",
                "remove": "Quitar",
                "removed": "Archivo quitado."
            },
            "file_download": "Descargar",
            "history": {
                "version": "Versión {number}",
                "by": "por {user}",
                "view": "Ver versión",
                "back": "Volver al historial",
                "current": "Actual",
                "empty": "Sin versiones.",
                "teacher_only": "Restaurar versiones es tarea del profesor."
            },
            "discussion": {
                "title": "Discusión",
                "type": "Tipo",
                "types": {
                    "question": "Pregunta",
                    "suggestion": "Sugerencia",
                    "justification": "Justificación",
                    "debate": "Debate"
                },
                "write": "Escribe tu comentario",
                "publish": "Publicar",
                "reply": "Responder",
                "replying_to": "Respondiendo a {user}",
                "empty": "Ningún comentario todavía. Empieza la discusión.",
                "teacher": "PROFESOR",
                "closed": "La discusión de esta wiki está cerrada. Puedes leer los comentarios, pero no publicar."
            },
            "feed": {
                "title": "Últimos cambios",
                "created": "creó la página {page}",
                "edited": "{summary} en {page}",
                "commented": "comentó en {page}",
                "empty": "Ningún cambio todavía."
            },
            "version_created": "Página creada",
            "version_edited": "Cambio",
            "version_restored": "Versión {number} restaurada",
            "version_teacher": "Cambio del profesor",
            "cannot_create": "No puedes crear páginas en esta wiki.",
            "cannot_edit": "No puedes editar esta página.",
            "conflict": "Otra persona modificó la página mientras editabas.",
            "saved": "Cambio guardado.",
            "comment_published": "Comentario publicado.",
            "error": "No se pudo completar. Inténtalo de nuevo."
        }
    },
    "pt-BR": {
        "common": {
            "and": "e",
            "save": "Salvar",
            "attach": "Anexar",
            "open": "Abrir",
            "information": "Informações",
            "confirm_action": "Confirmar ação?",
            "confirm": "Confirmar",
            "cancel": "Cancelar",
            "free": "Gratuito",
            "public": "Público",
            "module": "Temporada",
            "modules": "Temporadas",
            "lesson": "Episódio",
            "lessons": "Episódios",
            "exercises": "Exercícios",
            "exercise": "Exercício",
            "topics": "Enquetes",
            "back": "Voltar",
            "details": "Detalhes",
            "views": "Visualizações",
            "courses": "Títulos",
            "course": "Título",
            "continue": "Continuar",
            "start": "Iniciar",
            "remove": "Remover",
            "apply": "Aplicar",
            "value": "Valor",
            "status": "Status",
            "payment_method": "Método de pagamento",
            "payment_error": "Falha ao finalizar compra! Não foi possível processar a transação, reveja os dados informados e tente novamente.",
            "due": "Vencimento",
            "installments": "Parcelas",
            "invoices": "Visualizar faturas",
            "all_invoices": "Todas as faturas",
            "recurrence": "Faturamento",
            "active": "Ativo",
            "inactive": "Inativo",
            "paid_value": "Valor pago",
            "to_due": "A vencer",
            "paid": "Pago",
            "paid_invoices": "Faturas pagas",
            "due_invoices": "Faturas a vencer",
            "plans": "Planos",
            "plan": "Plano",
            "blog": "Blog",
            "contact": "Contato",
            "products": "Produtos",
            "tickets": "Tickets",
            "notifications": "Notificações",
            "name": "Nome",
            "showing": "Mostrando",
            "to": "a",
            "of": "de",
            "results": "Resultado",
            "unique_invoice": "Fatura única",
            "paid_date": "Data do pagamento",
            "issue_date": "Data da compra",
            "expired": "Vencido",
            "canceled": "Cancelado",
            "processing": "Processando",
            "analyze": "Em analise",
            "search": "Pesquisar",
            "print_billet": "Imprimir boleto",
            "send": "Enviar",
            "close": "Fechar",
            "attention": "Atenção!",
            "empty_exercises": "Você não respondeu a todas as perguntas, deseja mesmo continuar?",
            "empty_alert": "Existem questões não respondidas",
            "final_grade": "Nota",
            "billet": "Boleto",
            "credit_card": "Cartão de Crédito",
            "debit_card": "Cartão de Débito",
            "edit": "Editar",
            "error": "Ocorreu um erro",
            "add": "Adicionar",
            "geolocation_block": "Localização não permitida",
            "required_field": "Campo obrigatório",
            "invalid_format": "Formato inválido",
            "geolocation_permission": "Ative a geolocalização do navegador para realizar login",
            "geolocation_unsupported": "Este navegador não possui suporte a geolocalização",
            "browser_support_file": "O navegador não possui suporte a esse tipo de arquivo",
            "download_file": "Baixar arquivo",
            "upload_error": "Não foi possível enviar o arquivo",
            "chat": "Chat",
            "description": "Descrição",
            "generate_invoice": "Gerar Fatura",
            "location": {
                "addresses": "Endereços",
                "address": "Endereço",
                "city": "Cidade",
                "number": "Número",
                "neighborhood": "Bairro",
                "state": "Estado",
                "zip_code": "CEP",
                "info": "Complemento"
            },
            "support_material": "Material de apoio",
            "overview": "Visão Geral",
            "empty_survey": "Não há enquetes no momento",
            "no_forum": "Nenhum fórum encontrado",
            "final_content": "Conteúdo final",
            "content": "Conteúdo",
            "buy": "Comprar",
            "about_course": "Sobre o Plano",
            "listing": "Listagem",
            "dashboard": "Painel",
            "cart": "Carrinho",
            "forum": "Fórum",
            "new": "Novo",
            "financial": "Financeiro",
            "config": "Configurações",
            "profile": "Perfil",
            "receipt": "Comprovante",
            "justify_answer": "Justifique sua resposta",
            "select_one": "Selecione ao menos uma opção",
            "load_more_content": "Carregar mais conteúdo",
            "title": "Título",
            "response": {
                "success": "Enviado com sucesso",
                "error": "Houve algum erro, tente novamente."
            },
            "expand": "Expandir",
            "see_less": "Ver menos",
            "anonymous": "Anônimo",
            "my_plans": "Meus planos",
            "unavailable": "Indisponível",
            "store": "Planos",
            "zip_not_found": "Não foi encontrado um endereço com esse CEP.",
            "zip_error": "Não foi possível carregar as informações do CEP.",
            "type_search": "Digite para pesquisar o país",
            "try_again": "Tentar novamente",
            "register": "Cadastre-se",
            "blocked": "Bloqueado",
            "duration": "Duração",
            "mark_all_as_read": "Marcar todas como lidas",
            "mark_all_as_read_count": "{count} notificações foram marcadas como lidas",
            "days": "dias",
            "loading": "Carregando...",
            "error_accessing_content": "Erro ao acessar o conteúdo."
        },
        "order": {
            "order": "Pagamento",
            "thanks": "Muito Obrigado por ter adquirido nosso conteúdo!",
            "info": "Informações do Pagamento",
            "recurrence_question": "Deseja vincular esta recorrência a um metodo de pagamento?",
            "value": "Valor Total do pagamento",
            "yes_link": "Sim, Desejo Vincular",
            "no_link": "Não",
            "go_to_dashboard": "Ir para dashboard",
            "link_recurrence": "Vincular pagamento recorrente do conteúdo",
            "status": {
                "success": "Muito Obrigado por ter adquirido nosso conteúdo!",
                "to_pay": "O pedido de pagamento foi realizado, aguarde o processamento.",
                "beaten": "Não foi possível realizar a operação. Entre em contato com o suporte.",
                "canceled": "Não foi possível realizar a operação. Tente novamente mais tarde ou entre em contato com o suporte.",
                "processing": "A transação está sendo processada.",
                "waiting": "A transação está aguardando liberação do departamento financeiro"
            }
        },
        "notification": {
            "title": "Notificações",
            "all": "Todas notificações"
        },
        "billing": {
            "billing": "Faturamento",
            "invoice": {
                "hash": "Número da Fatura",
                "descrition": "Descrição da Fatura",
                "invoice": "Fatura",
                "invoices": "Faturas",
                "show": "Exibir fatura",
                "pay": "Pagar Fatura",
                "duplicate": {
                    "title": "Segunda Via",
                    "generate": "Gerar Segunda Via"
                },
                "total": "Valor final da fatura",
                "fee": "Multa",
                "interest": "Juros",
                "payed": "Esta fatura ja foi paga",
                "processing": "Processando pagamento",
                "expiry": "Data de Vencimento da fatura",
                "expiry_duplicate": "Data de Vencimento Segunda Via",
                "goto_payment": "Ir para pagamento",
                "canceled": "Fatura foi cancelada",
                "interest_per_days": "ao dia após vencimento da primeira fatura",
                "billet": {
                    "show": "Exibir boleto",
                    "expirated": "Fatura expirada"
                }
            },
            "recurrence": {
                "recurrence": "Recorrência",
                "invoices": "Faturas da Recorrência",
                "hash": "Número da Recorrência",
                "description": "Descrição da Recorrência",
                "due": "Próximo Vencimento",
                "view": "Visualizar Recorrência",
                "payment_type": "Forma de Pagamento Vinculado",
                "info": "Informações da Recorrência",
                "name": "Nome da Recorrência",
                "plan": "Plano da Recorrência",
                "value": "Valor da Recorrência",
                "cicle": "Ciclos",
                "linked_payment": "Esta recorrência esta vinculada com método de pagamento ",
                "no_linked_payment": "Esta recorrência não esta vinculada com nenhum método de pagamento",
                "link_payment": "Vincular Método de Pagamento",
                "unlink_payment": "Desvincular Método de Pagamento",
                "null_recurring_payment": "Nenhum meio de pagamento vinculado",
                "no_payment_available": "No momento não há nenhuma plataforma de pagamentos disponível para habilitar a recorrência selecionada.",
                "status_codes": [
                    "Desativada",
                    "Ativada",
                    "Cancelada",
                    "Processando"
                ]
            }
        },
        "glossary": {
            "title": "Glossário",
            "subtitle": "Consulte os termos e conceitos dos seus cursos.",
            "search": "Pesquisar termo",
            "all": "Todos",
            "category": "Categoria",
            "all_categories": "Todas as categorias",
            "course": "Curso",
            "general": "Glossário geral",
            "empty": "Nenhum termo encontrado.",
            "examples": "Exemplos de utilização",
            "synonyms": "Sinônimos",
            "related": "Veja também",
            "back": "Voltar ao glossário",
            "disabled": "O glossário não está disponível nesta plataforma.",
            "not_found": "Termo não encontrado.",
            "preview_notice": "Visão do aluno: é assim que os alunos veem o glossário.",
            "menu": "Glossário"
        },
        "tags": {
            "id": "Código",
            "year": "Ano",
            "month": "Mês",
            "next": "Próximo",
            "previous": "Voltar"
        },
        "certificate": {
            "title": "Certificado",
            "description": "Certificado de conclusão, clique no trofeu para obter o certificado",
            "print": "Imprimir",
            "download": "Baixar",
            "validate": "Link para validar o Certificado",
            "code": "Digite o códito do certificado para validar",
            "validate_button": "Validar",
            "success": "Esse certificado é válido, confira abaixo",
            "error": "por favor digite um código de certificado valido",
            "validate_description": "Validar Certificado",
            "state": {
                "valid": "Certificado válido",
                "expired": "Certificado expirado",
                "not_found": "Certificado não encontrado",
                "disabled": "Validação pública desligada para este certificado",
                "valid_text": "Este certificado foi emitido pela plataforma e é autêntico.",
                "expired_text": "Este certificado existe, mas a data de validade já passou.",
                "not_found_text": "Não encontramos nenhum certificado com este código. Confira o código e tente de novo.",
                "disabled_text": "O responsável pelo certificado não liberou a validação pública."
            },
            "summary": {
                "student": "Aluno",
                "content": "Conteúdo",
                "emitted_at": "Emitido em",
                "valid_until": "Válido até",
                "code": "Código"
            },
            "validate_at": "Valide em"
        },
        "captcha": {
            "title": "Erro na verificação do captcha!",
            "none": "Captcha não criado ainda.",
            "image": "A imagem selecionada está incorreta.",
            "audio": "A letra ou número está incorreta(o).",
            "incomplete": "Você deve completar o captcha.",
            "wait": "Excesso de tentativas, aguarde ",
            "frontend": {
                "accessibilityAlt": "Ícone de Som",
                "accessibilityTitle": "Opção de Acessibilidade: ouça uma questão e responda à mesma!",
                "accessibilityDescription": "Escreva em baixo a <strong>resposta</strong> ao que ouve. Números ou palavras:",
                "explanation": "Clique ou toque no/a <strong>ANSWER</strong>",
                "refreshAlt": "Ícone de recarregar",
                "refreshTitle": "Recarregar: obtenha novas imagens e opção de acessibilidade!"
            },
            "images": {
                "Airplane": "Avião",
                "Balloons": "Balões",
                "Camera": "Camera",
                "Car": "Carro",
                "Cat": "Gato",
                "Chair": "Cadeira",
                "Clip": "Clipe",
                "Clock": "Relógio",
                "Cloud": "Nuvem",
                "Computer": "Computador",
                "Envelope": "Envelope",
                "Eye": "Olho",
                "Flag": "Bandeira",
                "Folder": "Pasta",
                "Foot": "Pé",
                "Graph": "Gráfico",
                "House": "Casa",
                "Key": "Chave",
                "Leaf": "Folha",
                "Light Bulb": "Lâmpada",
                "Lock": "Cadeado",
                "Magnifying Glass": "Lupa",
                "Man": "Homem",
                "Music Note": "Nota musical",
                "Pants": "Calça",
                "Pencil": "Lapis",
                "Printer": "Impressora",
                "Robot": "Robô",
                "Scissors": "Tesoura",
                "Sunglasses": "Óculos",
                "Tag": "Etiqueta",
                "Tree": "Árvore",
                "Truck": "Caminhão",
                "T-Shirt": "Camisa",
                "Umbrella": "Guarda-Chuva",
                "Woman": "Mulher",
                "World": "Planeta"
            }
        },
        "lesson": {
            "tabs": {
                "overview": "Visão geral",
                "polls": "Enquete",
                "forum": "Fórum"
            },
            "live": {
                "unavailable": "Aula ao vivo não disponível",
                "start_at": "Inicio"
            },
            "conference": {
                "unavailable": "Videoconferência não disponível",
                "start_at": "Inicio",
                "waiting_teacher": "Aguardando professor",
                "teacher_not_started": "A transmissão ainda não foi iniciada."
            },
            "scorm": {
                "no_entry_sco": "Pacote SCORM não possui SCO de entrada.",
                "init_error": "Erro ao iniciar sessão SCORM."
            },
            "answer_placeholder": "Escreva sua resposta",
            "finish_exercise": "Finalizar exercício",
            "redo": "Refazer",
            "upload_empty": "O campo de upload não pode ficar em branco",
            "answer_download": "Download resposta",
            "exercise_waiting": "Exercício aguardando correção.",
            "exercise_revised": "Exercício corrigido.",
            "conference_lesson": "Palestra: Você poderá participar apenas como ouvinte",
            "conference_discussion": "Debate: você poderá interagir, selecione a camera e o microfone",
            "corrected_on": "Corrigido em"
        },
        "profile": {
            "secondary": {
                "title": "Login Secundário",
                "created": "Login Secundário Criado",
                "deleted": "Login Secundário Deletado",
                "create": "Criar Login Secundário",
                "delete": "Excluir Login Secundário",
                "warning": "Após a exclusão o email perderá completamente a associação com sua conta!",
                "new_secondary": "Criar novo usuário",
                "new_secondary_over_limit": "Limite de usuários secundários atingido"
            },
            "info": "Informações do Perfil",
            "owner": "Login Principal",
            "photo": "Foto do Perfil",
            "additional_info": "Informações adicionais",
            "category": "Categoria",
            "document_not_unique": "Já existe um assinante com o documento cadastrado",
            "delete_account": "Apagar conta",
            "delete_warning": "TODOS os seus dados pessoais, cursos adquiridos, progresso em aulas,\n    exercícios realizados, certificados, entre outros serão removidos da plataforma e",
            "recover_warning": "NÃO PODERÃO SER RECUPERADOS.",
            "want_continue": " Deseja continuar?"
        },
        "financial": {
            "sales_limit_exceeded": "Limite de vendas excedido.",
            "create_coupon": "Criar cupom",
            "create_plan": "Criar plano",
            "invoices": {
                "attachment_success": "Comprovante salvo com sucesso",
                "attachment_failed": "Falha ao salvar o comprovante"
            },
            "deposit": {
                "title": "Dados para o depósito",
                "button": "Enviar comprovante"
            },
            "recurrences": {
                "monthly": "Mensal",
                "bimonthly": "Bimestral",
                "quarterly": "Trimestral",
                "semiannual": "Semestral",
                "yearly": "Anual",
                "month": "1 mês",
                "year": "1 ano",
                "months": "{months} meses",
                "years": "{years} anos",
                "cycles": {
                    "cycles": "Ciclos",
                    "infinite": "Infinito",
                    "infinite_description": "A recorrência será gerada por um tempo indeterminado, ou até a aluno cancelar o plano",
                    "custom": "Customizado",
                    "custom_description": "A recorrência será gerada por um tempo determinado, podendo ser no máximo 20 vezes",
                    "month": "1 mês",
                    "year": "1 ano",
                    "months": "{months} meses",
                    "years": "{years} anos",
                    "days": "{days} dias"
                }
            }
        },
        "pdf": {
            "invoice_generated": "Fatura Gerada",
            "invoice_number": "N° Fatura",
            "issue_date": "Emissão",
            "due_date": "Vencimento",
            "plan_name": "Plano",
            "items": "Itens",
            "value": "Valor",
            "total": "Total"
        },
        "topic": {
            "topic_title": "Título do tópico",
            "post": "Postar",
            "title": "título",
            "await": "Aguardando aprovação",
            "question": "conteúdo tópico",
            "new_moderated": "Esse fórum é moderado pelo adiministrador, seu tópico aparecerá na listagem quando for aprovado.",
            "needs_login": "Realize login ou crie uma conta para interagir no tópico"
        },
        "students": {
            "field_exits": "Já existe um assinante com o valor \"{value}\" no campo {name}",
            "plan": {
                "remove": " Atenção! Ao remover um plano associado a conta de um aluno(a) levará a perda do registro de progresso nos relatórios. Caso este plano possua uma recorrência associada será necessário removê-la manualmente. Deseja prosseguir com a exclusão do plano deste aluno(a)?",
                "change_status": "Atenção! Ao realizar esta ação, será atualizado o status do plano para o aluno(a). Se a \"Situação\" do plano for atualizado para \"Ativado\" irá desbloquear o acesso para o aluno e se for atualizado para \"Desativado\" irá bloquear o acesso para o aluno. Caso este plano possua uma recorrência associada deverá ser mudado o seu \"Status\" manualmente. Deseja prosseguir com a alteração de status do plano deste aluno(a)?"
            }
        },
        "notification_templates": {
            "APP_TICKET_CREATED": {
                "name": "Novo Ticket Criado",
                "body": "O administrador [[$user_name]] criou o ticket #[[$ticket_id]]."
            },
            "APP_TICKET_REPLY": {
                "name": "Ticket Respondido",
                "body": "Nova resposta do administrador [[$user_name]] no ticket #[[$ticket_id]]."
            },
            "APP_TOPIC_REPLY": {
                "name": "Nova Resposta no Tópico do Fórum",
                "body": "Nova resposta do tópico [[$topic_name]] no fórum do conteúdo [[$content_name]]."
            },
            "APP_TOPIC_REPLY_APPROVED": {
                "name": "Resposta Aprovada no Tópico do Fórum",
                "body": "Sua resposta no tópico [[$topic_name]] do conteúdo [[$content_name]] foi aprovada."
            },
            "APP_INVOICE_PAID": {
                "name": "Fatura Paga",
                "body": "Pagamento da fatura #[[$invoice_id]] no valor de [[$invoice_value]] referente ao plano [[$plan_name]] aprovado com sucesso."
            },
            "APP_INVOICE_DUE_DATE": {
                "name": "Fatura Vencida",
                "body": "Detectamos que a fatura #[[$invoice_id]] no valor de [[$invoice_value]], venceu na data [[$invoice_due_date]] clique para mais informações."
            },
            "APP_CORRECTED_EXERCISE": {
                "name": "Exercício Corrigido",
                "body": "O exercício [[$exercise_name]] foi [[$exercise_approve]], confira sua nota."
            },
            "APP_NEW_EXERCISE": {
                "name": "Novo Exercício",
                "body": "O exercício [[$exercise_name]] foi adicionado a um conteúdo do plano [[$plan_name]]."
            },
            "APP_SUSPENDED_PLAN": {
                "name": "Plano Suspenso",
                "body": "O plano [[$plan_name]] foi suspenso devido a pagamentos pendentes. Clique para mais informações."
            },
            "APP_NEW_MODULE": {
                "name": "Nova Temprada",
                "body": "A temporada [[$module_name]] foi adicionada ao título [[$course_name]] do plano [[$plan_name]]."
            },
            "APP_NEW_LESSON": {
                "name": "Novo Episódio",
                "body": "o episódio [[$lesson_name]] foi adicionado a um conteúdo do plano [[$plan_name]]."
            }
        },
        "exercise": {
            "time": {
                "title": "Exercício com tempo limite para resposta",
                "description": "Após iniciar o exercício o envio deve acontecer até esgotar o tempo limite, caso contrário o envio será automático",
                "rules": "Depois de iniciado o timer não irá parar mesmo se a página for recarregada ou ocorrer uma mudança de conteúdo",
                "remaining": "Tempo restante",
                "limit": "Exercício com tempo limite"
            },
            "validate": {
                "check_error": "Marque alguma alternativa",
                "some_question_no_anwser": "Responda todas as questões"
            }
        },
        "login": {
            "signin": "Entrar",
            "signout": "Sair",
            "register": "Criar Conta",
            "new_account": "Criar uma nova conta",
            "name": "Nome",
            "email": "Email",
            "email_confirmation": "Confirme o Email",
            "email_reset": "Redefinir Email",
            "email_change": "Alterar Email",
            "domain_invalid": "Domínio de e-mail incompatível para a categoria selecionada",
            "document": "Documento",
            "document_type": "Tipo de Documento",
            "disconnect_users": "Desconectar dispositivos",
            "device_limit_hint": "Limite de dispositivos conectados atingido. Você pode desconectar os outros dispositivos e continuar neste.",
            "disconnect_and_signin": "Desconectar outros dispositivos e entrar",
            "remember": "Lembrar Login",
            "validation": {
                "email": "Email é obrigatório",
                "password": "Password é obrigatório"
            },
            "messages": {
                "update_password": "Atualize sua senha para continuar",
                "success": "Login realizado com sucesso",
                "error": "Credenciais inválidas"
            },
            "recovery": {
                "success": "Você receberá um e-mail com o link para redefinir sua senha",
                "error": "E-mail não encontrado"
            },
            "password": {
                "title": "Senha",
                "confirm": "Confirme a senha",
                "change": {
                    "title": "Alterar Senha",
                    "success": "Senha Alterada!",
                    "error": "Erro ao alterar a senha"
                },
                "forgot": "Esqueceu a senha?",
                "reset": "Redefinir a senha"
            },
            "account_created": "Conta criada com sucesso! Redirecionando...",
            "email_already_exists": "Email já possui uma conta registrada",
            "document_type_required": "Documento é obrigatório",
            "subscribe_message": "Crie sua conta para ter acesso a ",
            "has_account": "Já possui uma conta?",
            "access_here": "Acesse aqui."
        },
        "chat": {
            "you_are_banned": "Você foi banido desse chat, consulte o administrador para mais informações",
            "you_are_accept": "Sua interação com o chat foi concedida",
            "cannot_approve": "Vocẽ não possui permissão para aprovar mensagens do chat",
            "cannot_ban": "Você não possui permissão para banir um usuário",
            "send_placeholder": "Digite sua menssagem...",
            "message_waiting": "Mensagem enviada. Aguarde a moderação.",
            "pending": "Aguardando aprovação",
            "message_sent_error": "Erro ao enviar mensagem",
            "end": "Chat encerrado",
            "needs_login": "Realize login ou crie uma conta para interagir no chat"
        },
        "wiki": {
            "my_wikis": "Minhas wikis",
            "title": "Wiki",
            "subtitle": "Construa o conteúdo junto com a turma.",
            "empty": "Você ainda não participa de nenhuma wiki.",
            "course": "Curso",
            "classroom": "Turma",
            "relation": {
                "general": "Geral",
                "plan": "Plano: {name}",
                "course": "Curso: {name}"
            },
            "open": "Abrir wiki",
            "status": {
                "not_started": "Abre em {date}",
                "editing": "Em edição",
                "closed": "Encerrada"
            },
            "deadline": {
                "ends_in": "Vence em {days} dia|Vence em {days} dias",
                "ends_today": "Vence hoje",
                "over": "Prazo encerrado",
                "none": "Sem prazo",
                "not_started": "Abre em {date}"
            },
            "closed_notice": "A edição desta wiki foi encerrada. Você ainda pode ler e consultar o histórico.",
            "not_started_notice": "Esta wiki abre para edição em {date} às {time}. Até lá, você pode ler o conteúdo.",
            "read_more": "Ler descrição completa",
            "read_less": "Recolher descrição",
            "participants": "participantes",
            "contributions": "contribuições",
            "last_update": "Última atualização",
            "today_at": "hoje às {time}",
            "yesterday": "ontem",
            "pages": "Páginas",
            "search_page": "Buscar página",
            "new_page": "Nova página",
            "new_page_title": "Título da página",
            "parent_page": "Página-mãe (opcional)",
            "no_parent": "Sem página-mãe",
            "create": "Criar página",
            "cancel": "Cancelar",
            "page_created": "Página criada.",
            "page_locked": "Página bloqueada pelo professor.",
            "locked_short": "Bloqueada",
            "no_pages": "Nenhuma página ainda.",
            "no_results": "Nenhuma página encontrada.",
            "select_page": "Escolha uma página para ler.",
            "tabs": {
                "read": "Ler",
                "edit": "Editar",
                "history": "Histórico",
                "discussion": "Discussão"
            },
            "last_edit": "Última edição: {user}, {date}",
            "editor": {
                "bold": "Negrito",
                "italic": "Itálico",
                "heading": "Título",
                "list": "Lista",
                "table": "Tabela",
                "link": "Link",
                "link_url": "Endereço do link",
                "insert": "Inserir",
                "summary": "Resumo da alteração (opcional)",
                "summary_placeholder": "Descreva o que você alterou.",
                "save": "Salvar alteração",
                "being_edited": "{user} está editando esta página…",
                "cannot_edit": "Você não pode editar esta página.",
                "conflict_title": "A página foi alterada por outra pessoa",
                "conflict_text": "Seu texto foi mantido abaixo. Compare com a versão atual e salve de novo quando ajustar.",
                "conflict_mine": "Meu rascunho",
                "conflict_theirs": "Versão atual",
                "use_current": "Descartar meu rascunho e carregar a versão atual",
                "keep_mine": "Continuar com meu rascunho",
                "unsaved": "Você tem alterações não salvas nesta página. Sair sem salvar?"
            },
            "files": {
                "send": "Enviar arquivo",
                "hint": "Imagens aparecem no texto; PDF, PPTX, DOCX, XLSX aparecem como arquivo para baixar. Até 25 MB.",
                "sent": "Arquivo enviado.",
                "invalid": "Arquivo não permitido. Envie PNG, JPG, GIF, WEBP, PDF, PPTX, DOCX ou XLSX de até 25 MB.",
                "uploading": "Enviando…",
                "remove": "Remover",
                "removed": "Arquivo removido."
            },
            "file_download": "Baixar",
            "history": {
                "version": "Versão {number}",
                "by": "por {user}",
                "view": "Ver versão",
                "back": "Voltar ao histórico",
                "current": "Atual",
                "empty": "Sem versões.",
                "teacher_only": "Restaurar versões é tarefa do professor."
            },
            "discussion": {
                "title": "Discussão",
                "type": "Tipo",
                "types": {
                    "question": "Pergunta",
                    "suggestion": "Sugestão",
                    "justification": "Justificativa",
                    "debate": "Debate"
                },
                "write": "Escreva seu comentário",
                "publish": "Publicar",
                "reply": "Responder",
                "replying_to": "Respondendo a {user}",
                "empty": "Nenhum comentário ainda. Comece a discussão.",
                "teacher": "PROFESSOR",
                "closed": "A discussão desta wiki está encerrada. Você pode ler os comentários, mas não publicar."
            },
            "feed": {
                "title": "Últimas alterações",
                "created": "criou a página {page}",
                "edited": "{summary} em {page}",
                "commented": "comentou em {page}",
                "empty": "Nenhuma alteração ainda."
            },
            "version_created": "Página criada",
            "version_edited": "Alteração",
            "version_restored": "Versão {number} restaurada",
            "version_teacher": "Alteração do professor",
            "cannot_create": "Você não pode criar páginas nesta wiki.",
            "cannot_edit": "Você não pode editar esta página.",
            "conflict": "A página foi alterada por outra pessoa enquanto você editava.",
            "saved": "Alteração salva.",
            "comment_published": "Comentário publicado.",
            "error": "Não foi possível concluir. Tente de novo."
        },
        "emails": {
            "verify": {
                "send_link": "Link Enviado",
                "send_obs": "Para ativar sua conta, acesse o e-mail cadastrado e confirme seus dados",
                "if_not_received_link": "Caso não tenha recebido o e-mail",
                "click_here_another_send": "click aqui",
                "expired_link": "Link expirado",
                "expired_obs": "Esse link esta indisponível. Acesse sua conta na plataforma de cursos online para enviar um novo link de confirmação",
                "access_account": "Click aqui para acessar sua conta",
                "activated_account": "Conta ativada com sucesso",
                "link_another_send": "Link enviado novamente",
                "fail_link_another_send": "Falha ao reenviar o link",
                "little_missing": "Falta pouco",
                "link_sent": "Enviamos um link de confirmação para o e-mail cadastrado. Para ativar sua conta, acesse o e-mail e confirme seus dados",
                "click_another_send": "Clique aqui para reenviar o link de confirmação"
            }
        },
        "empty": {
            "unique_invoice_title": "Sem faturas para mostrar",
            "unique_invoice_subtitle": "Aqui aparecerão todas suas faturas únicas.",
            "recurrence_title": "Sem recorrências para mostrar",
            "recurrence_subtitle": "Aqui aparecerão todas suas recorrências.",
            "filter_title": "Sua busca não retornou nenhum resultado",
            "filter_subtitle": "Tente novamente com novos parâmetros",
            "topic_title": "Nenhum tópico encontrado"
        },
        "auth": {
            "failed": "Credenciais inválidas",
            "device": "Limite de dispositivos conectado com esta conta atingido",
            "deactivated": "Aluno está suspenso da plataforma!"
        },
        "form": {
            "address": {
                "country": "País",
                "state": "Estado",
                "city": "Cidade",
                "address": "Endereço",
                "number": "Número",
                "neighborhood": "Bairro",
                "info": "Complemento",
                "cep": "CEP",
                "invalid_zip": "CEP inválido",
                "fill_zip": "Preencha o campo CEP"
            },
            "select_option": "Selecione uma opção"
        },
        "content": {
            "course_content": "Conteúdo do título",
            "lesson_content": "Conteúdo do episódio",
            "description": "Descrição",
            "download_content": "Conteúdo para download",
            "lock": {
                "PLAN_EXPIRED": "Esse plano expirou",
                "PLAN_UNAVAILABLE": "Plano indisponível",
                "SCHEDULE": "Conteúdo agendado {details}",
                "SCHEDULE_SALE": "Liberado após {details}",
                "PROGRESS": "Progresso mínimo {details} não atingido",
                "GRADE": "Nota mínima {details} não atingida",
                "AVAILABLE": "Conteúdo disponível",
                "UNAVAILABLE": "Conteúdo indisponível",
                "VIEWS_LIMIT": "Limite de visualizações atingido",
                "WAITING_AUTHORIZATION": "Aguardando autorização",
                "WAITING_EXTERNAL_STATUS": "Matrícula não confirmada",
                "NOT_FREE_AFTER_CONTENT": "É necessário esperar {details} dias até liberar esta aula ou desbloquear o conteúdo anterior."
            },
            "uploads": {
                "url": "Url",
                "open_link": "Abrir Arquivo",
                "upload": "Upload",
                "title": "Uploads",
                "create": "Enviar Arquivos",
                "edit": "Editar arquivo",
                "files": "Arquivos",
                "file": "Arquivo",
                "various_files": "Arquivos diversos",
                "unsupported_preview": "Pré-visualização não disponível",
                "name": "Nome",
                "clear_list": "Limpar fila",
                "description": "Descrição",
                "send_file": "Enviar arquivo",
                "send_image": "Enviar imagem",
                "send_media": "Enviar arquivos",
                "message": "Arraste e solte aqui seu arquivo",
                "info": "Ou",
                "remove": "Remover arquivo",
                "cancel": "Cancelar envio",
                "confirm": "Tem certeza que deseja cancelar o envio?",
                "unsupported": "O seu navegador não suporta o envio arrastando o arquivo",
                "fallback": "Porfavor utilize o formulário para enviar o arquivo",
                "type": "Não é possivel enviar arquivos com esse formato",
                "exceeded": "Envie no máximo",
                "once": "por vez",
                "error": "Falha ao enviar arquivo.",
                "canceled": "Envio cancelado",
                "validate": "Selecione um arquivo",
                "created_at": "Data de Envio",
                "sent": "Enviado",
                "size": "Tamanho",
                "change": "Enviar Arquivo",
                "attachment": "Anexo",
                "docs": "Documentos",
                "images": "Imagens",
                "videos": "Vídeos",
                "audios": "Áudios",
                "all": "Todos os arquivos",
                "select": "Selecionar",
                "use": "Selecionar",
                "media_gallery": "Galeria de mídias",
                "rules_failed": "Voce atingiu o limite máximo de downloads"
            },
            "exercise": {
                "exercise": "Exercício",
                "questions": "Questões:",
                "utilization": "Aproveitamento"
            },
            "lesson": {
                "video": "Conteúdo em Vídeo",
                "video_n": "Vídeo",
                "upload": "Arquivo de Apoio"
            },
            "type": {
                "live": "Ao vivo",
                "file": "Arquivo"
            },
            "open": {
                "new_tab": "Abrir em Nova Guia"
            }
        },
        "cart": {
            "recurrence": {
                "title": "Recorrências",
                "monthly": "Mensal",
                "bimonthly": "Bimestral",
                "quarterly": "Trimestral",
                "semiannual": "Semestral",
                "yearly": "Anual",
                "custom": "Cobrados a cada",
                "days": "dias",
                "change_payment": "Escolha a forma de pagamento da recorrência",
                "cpf": "CPF",
                "area_code": "Código de Área",
                "phone_number": "Número do telefone",
                "name": "Nome",
                "holder": "Nome",
                "gerencia_net": "Gerencia Net",
                "birth": "Data de Nascimento",
                "credit_card_brand": "Bandeira",
                "credit_card_number": "Número",
                "credit_card_cvv": "CVV",
                "credit_card_expiration_month": "Mês de Expiração",
                "credit_card_expiration_year": "Ano de Expiração",
                "card_holder": "Nome do Titular (igual ao cartão)",
                "holder_cpf": "CPF do Titular",
                "payment_alert": "Só é permitido 1 item do tipo recorrente no carrinho se a forma de pagamento for GerenciaNet",
                "approve_text": "Aprovar a Recorrência",
                "have_recurrence": "Atenção, você ja contem algum item no seu carrinho, para adicionar um item recorrente é preciso que finalize a compra ou limpe do carrinho"
            },
            "coupon": {
                "has_coupon": "Possui um cupom de desconto?",
                "placeholder": "CÓDIGO",
                "apply": "Aplicar",
                "discount_coupon": "Cupom de desconto",
                "coupon": "Cupom",
                "add": "Aplicar um cupom de desconto"
            },
            "add_item": {
                "failed": "Falha ao adicionar item ao carrinho",
                "recurrence_failed": "Item recorrente já adicionado ao carrinho"
            },
            "pay": "Realizar Pagamento",
            "change_payment": "Preencha os dados de pagamento",
            "cart": "Carrinho de Compra",
            "go_to_cart": "Ir ao carrinho",
            "subscribe": "Inscrever-se",
            "add_to_cart": "Adicionar ao carrinho",
            "access_plan": "Acessar Plano",
            "plan_info": "Informações do plano",
            "payment_type": "Forma de pagamento",
            "product": "Produto",
            "price": "Preço",
            "checkout": "Pagamento",
            "type": "Período do Plano",
            "type_recurrence": "Pagamento Recorrente",
            "type_unique": "Pagamento Único",
            "discount": "Disconto",
            "total": "Total",
            "finish": "Finalizar",
            "empty": "O seu carrinho está vazio",
            "empty_message": " Antes de ir para o checkout você deve adicionar algum produto ao seu carrinho.",
            "empty_button": "Continuar comprando",
            "currency": "Moeda",
            "filter": "Filtrar",
            "filter_by": "Filtrar por",
            "order_by": "Ordenar por",
            "remove_failed": "Falha ao tentar remover item do carrinho",
            "admin_message": "Não foi possível realizar a compra, certifique-se de estar logado como assinante",
            "plans": {
                "types": "Tipos de Planos",
                "public": "Público",
                "free": "Grátis",
                "single_purchase": "Pagamento Único",
                "recurrence": "Recorrente",
                "value": "Valor do Plano",
                "categories": "Categorias",
                "no_category": "Sem categoria"
            },
            "min_price": "Menor Preço",
            "max_price": "Maior Preço",
            "clean_filters": "Limpar Filtros",
            "clear": "Limpar o Carrinho",
            "item_added": "Item Adicionado ao carrinho!",
            "code": "Código",
            "code_empty": "Código obrigatório",
            "free_item_add": "Inscrito com sucesso!",
            "free_item_wait": "Plano adicionado a sua conta, aguarde a autorização de sua inscrição",
            "deleted": "Item do carrinho removido com sucesso!",
            "item": {
                "added": "Item adicionado ao carrinho!",
                "removed": "Item removido do carrinho",
                "exists": "Produto já adicionado ao carrinho"
            },
            "checkout_errors": {
                "brand_not_identified": "Não foi possível identificar a bandeira do cartão. Confira o número digitado ou selecione a bandeira manualmente.",
                "brand_not_accepted": "A bandeira {brand} não é aceita por este meio de pagamento.",
                "pending_invoice_multiple": "Já existe uma fatura em aberto para um dos itens do carrinho. Pague a fatura em Financeiro ou remova o item para continuar.",
                "payment_reversed": "A cobrança no cartão foi cancelada automaticamente e nenhum valor será debitado.",
                "payment_not_reversed": "Não foi possível cancelar a cobrança automaticamente. Entre em contato com o suporte informando o horário da compra."
            }
        },
        "blog": {
            "share": "Compartilhar",
            "share_on": "Compartilhar no {social}",
            "copy_url": "Copiar url",
            "posts": {
                "by": "Publicado por",
                "views": "Visualizações",
                "search": "Buscar publicação",
                "latest": "Ultimas publicações",
                "no_data": "Nenhuma publicação"
            },
            "comments": {
                "title": "Comentários",
                "reply_to": "Resposta a {author}",
                "no_replies": "Nenhuma resposta",
                "show_replies": "Mostrar respostas",
                "login_comment": "Faça login e deixe seu comentário",
                "form_title": "Deixe um comentário",
                "no_data": "Nenhum comentário até o momento",
                "send": "Enviar",
                "reply": "Responder",
                "replies": "Respostas",
                "load_more": "Ver mais comentários"
            },
            "categories": {
                "title": "Categorias",
                "more": "Mostrar mais"
            },
            "tags": {
                "see_more": "Veja mais sobre:"
            }
        },
        "header": {
            "cart": {
                "empty": "Seu carrinho está vazio."
            },
            "profile": {
                "title": "Perfil",
                "logout": "Sair",
                "welcome": "Bem-vindo",
                "notifications": "Notificações",
                "cart": "Carrinho",
                "menus": "Menus"
            },
            "notifications": {
                "you_have": "Você tem",
                "notification": "notificação.",
                "notifications": "notificações.",
                "all": "Ver todas",
                "ago": "atrás",
                "marker_all_read": "Marcar todas como lidas"
            }
        },
        "support": {
            "submit": "Enviar Contato",
            "support_form": "Formulário de Contato",
            "label": "Assunto",
            "invalid_email": "Email Inválido",
            "sent_success": "Email de contato enviado com sucesso!",
            "chat": {
                "title": "Chat de Suporte",
                "attendant": "Atendente",
                "send_placeholder": "Digite sua menssagem...",
                "err_send_message": "Erro ao enviar mensagem"
            },
            "departments": {
                "department": "Departamento"
            },
            "tickets": {
                "ticket": "Ticket",
                "view": "Visualizar Ticket",
                "id": "ID",
                "all": "Todos os tickets",
                "title": "Assunto",
                "search": "Buscar por título ou ID",
                "reply": "Mensagem",
                "reply_error": "Falha ao enviar resposta",
                "created_at": "Criado em",
                "status": "Situação",
                "close": "Fechar Ticket",
                "new": "Novo ticket",
                "send": "Mensagem enviada",
                "situation": {
                    "all": "Todos",
                    "OPEN": "Aberto",
                    "WAITING_STUDENT": "Aguardando sua resposta",
                    "WAITING_OP": "Aguardando operador",
                    "CLOSED": "Fechado",
                    "RESOLVED": "Resolvido",
                    "IN_PROCESS": "Em atendimento"
                }
            },
            "map": {
                "contact_info": "Informações de Contato",
                "telephone": "Telefone",
                "address": "Endereço"
            }
        },
        "documents": {
            "type": "Tipo de documento",
            "invalid": "Documento {type} inválido"
        },
        "course": {
            "tabs": {
                "wiki": "Wiki da turma",
                "glossary": "Glossário",
                "overview": "Visão geral",
                "content": "Conteúdo",
                "forum": "Fórum"
            },
            "start": "Iniciar",
            "continue": "Continuar",
            "modules": "Módulos",
            "lessons": "Episódios",
            "exercises": "Exercíos",
            "topics": "Enquete",
            "show_more": "Mostrar Mais",
            "module_no_content": "Esse módulo não possui conteúdo",
            "course_no_content": "No momento não há conteúdo disponível para visualização"
        },
        "tickets": {
            "empty": {
                "title": "Ops! Você não tem nenhum ticket",
                "subtitle": "Você pode criar um novo ticket clicando abaixo",
                "button": "Novo ticket"
            }
        },
        "validation": {
            "accepted": "O campo {attribute} deve ser aceito.",
            "active_url": "O campo {attribute} não é uma URL válida.",
            "after": "O campo {attribute} deve ser uma data posterior a {date}.",
            "after_or_equal": "O campo {attribute} deve ser uma data posterior ou igual a {date}.",
            "alpha": "O campo {attribute} só pode conter letras.",
            "alpha_dash": "O campo {attribute} só pode conter letras, números e traços.",
            "alpha_num": "O campo {attribute} só pode conter letras e números.",
            "array": "O campo {attribute} deve ser uma matriz.",
            "before": "O campo {attribute} deve ser uma data anterior {date}.",
            "before_or_equal": "O campo {attribute} deve ser uma data anterior ou igual a {date}.",
            "between": {
                "numeric": "O campo {attribute} deve ser entre {min} e {max}.",
                "file": "O campo {attribute} deve ser entre {min} e {max} kilobytes.",
                "string": "O campo {attribute} deve ser entre {min} e {max} caracteres.",
                "array": "O campo {attribute} deve ter entre {min} e {max} itens."
            },
            "err": "Erro de validação",
            "boolean": "O campo {attribute} deve ser verdadeiro ou falso.",
            "confirmed": "O campo {attribute} de confirmação não confere.",
            "date": "O campo {attribute} não é uma data válida.",
            "date_format": "O campo {attribute} não corresponde ao formato {format}.",
            "different": "Os campos {attribute} e {other} devem ser diferentes.",
            "digits": "O campo {attribute} deve ter {digits} dígitos.",
            "digits_between": "O campo {attribute} deve ter entre {min} e {max} dígitos.",
            "dimensions": "O campo {attribute} tem dimensões de imagem inválidas.",
            "distinct": "O campo {attribute} campo tem um valor duplicado.",
            "email": "O campo {attribute} deve ser um endereço de e-mail válido.",
            "exists": "O campo {attribute} selecionado é inválido.",
            "file": "O campo {attribute} deve ser um arquivo.",
            "filled": "O campo {attribute} deve ter um valor.",
            "image": "O campo {attribute} deve ser uma imagem.",
            "in": "O campo {attribute} selecionado é inválido.",
            "in_array": "O campo {attribute} não existe em {other}.",
            "integer": "O campo {attribute} deve ser um número inteiro.",
            "ip": "O campo {attribute} deve ser um endereço de IP válido.",
            "ipv4": "O campo {attribute} deve ser um endereço IPv4 válido.",
            "ipv6": "O campo {attribute} deve ser um endereço IPv6 válido.",
            "json": "O campo {attribute} deve ser uma string JSON válida.",
            "max": {
                "numeric": "O campo {attribute} não pode ser superior a {max}.",
                "file": "O campo {attribute} não pode ser superior a {max} kilobytes.",
                "string": "O campo {attribute} não pode ser superior a {max} caracteres.",
                "array": "O campo {attribute} não pode ter mais do que {max} itens."
            },
            "mimes": "O campo {attribute} deve ser um arquivo do tipo: {values}.",
            "mimetypes": "O campo {attribute} deve ser um arquivo do tipo: {values}.",
            "min": {
                "numeric": "O campo {attribute} deve ser pelo menos {min}.",
                "file": "O campo {attribute} deve ter pelo menos {min} kilobytes.",
                "string": "O campo {attribute} deve ter pelo menos {min} caracteres.",
                "array": "O campo {attribute} deve ter pelo menos {min} itens."
            },
            "not_in": "O campo {attribute} selecionado é inválido.",
            "numeric": "O campo {attribute} deve ser um número.",
            "present": "O campo {attribute} deve estar presente.",
            "regex": "O campo {attribute} tem um formato inválido.",
            "required": "O campo {attribute} é obrigatório.",
            "required_if": "O campo {attribute} é obrigatório quando {other} for {value}.",
            "required_unless": "O campo {attribute} é obrigatório exceto quando {other} for {values}.",
            "required_with": "O campo {attribute} é obrigatório quando {values} está presente.",
            "required_with_all": "O campo {attribute} é obrigatório quando {values} está presente.",
            "required_without": "O campo {attribute} é obrigatório quando {values} não está presente.",
            "required_without_all": "O campo {attribute} é obrigatório quando nenhum dos {values} estão presentes.",
            "same": "Os campos {attribute} e {other} devem corresponder.",
            "size": {
                "numeric": "O campo {attribute} deve ser {size}.",
                "file": "O campo {attribute} deve ser {size} kilobytes.",
                "string": "O campo {attribute} deve ser {size} caracteres.",
                "array": "O campo {attribute} deve conter {size} itens."
            },
            "string": "O campo {attribute} deve ser uma string.",
            "timezone": "O campo {attribute} deve ser uma zona válida.",
            "unique": "O campo {attribute} já está sendo utilizado.",
            "uploaded": "Ocorreu uma falha no upload do campo {attribute}.",
            "url": "O campo {attribute} tem um formato inválido.",
            "white_space": "O campo {attribute} não deve conter espaços em branco",
            "reserved_in_system": "Esse nome é reservado pelo sistema.",
            "custom": {
                "already_exists": "Já existe um registro com esse valor",
                "fields": "Campos obrigatórios não preenchidos",
                "document": {
                    "unique": "Já existe um assinante com o documento cadastrado"
                },
                "email": {
                    "unique": "Já existe um assinante com o email cadastrado"
                }
            },
            "attributes": {
                "document": "documento"
            }
        },
        "dashboard": {
            "courses": "Títulos",
            "content": "Conteúdo",
            "lessons": "Episódios",
            "exercises": {
                "title": "Exercícios",
                "answers": "Questões Respondidas"
            },
            "plan": {
                "change": "Alterar Plano",
                "external_status_title": "Confirmação de matrícula",
                "external_status_description": "Olá {name}, estamos ansiosos para iniciar as atividades. <br> Para confirmar a matrícula clique no botão abaixo.",
                "external_status_ok": "Confirmar matrícula",
                "unavailable_content": "Conteúdo ainda não disponível",
                "release_date": "Data de lançamento: "
            },
            "plans": "Planos",
            "in_progress": "Em Andamento",
            "no_plans": "Você não tem nenhum plano",
            "empty_message": "Adquira ao menos um plano para ter acesso ao seu conteúdo",
            "redirect_showcase": "Vitrine de Planos",
            "access": "Acessar",
            "start": "Iniciar",
            "continue": "Continuar",
            "disabled": "Desativado",
            "progress": "Progresso",
            "notifications": {
                "title": "Notificações Dashboard",
                "name": "Notificações"
            },
            "expiration_days": "Dias para expiração",
            "expiration_date": "Data de expiração",
            "tomorrow": "Amanhã",
            "today": "Hoje",
            "expired": "Expirado"
        }
    }
}
